<template>
  <div id="app">
    <v-app>
      <error-popup></error-popup>
    <div v-if="isLoggedIn">
      <v-card
          class="mb-10"
          flat
          tile
      >

        <v-toolbar color="secondary" height="90">
          <v-toolbar-title class="no_highlight robotoBoldFont">LTS Lotto Test Server</v-toolbar-title>
          <v-spacer></v-spacer>
          <ul>
            <v-toolbar-items>
            <template v-for="item in menuItems">
              <li :key="item.link" @click="itemClicked(item)" class="no_highlight robotoMediumFont menuItem" :class="currentPath && currentPath === item.link ? 'active' : ''">{{ item.title }}</li>
          </template>
            </v-toolbar-items>
          </ul>
          <v-btn color="primary" @click="logoutClicked">Ausloggen</v-btn>
          <div class="user-info-section">
            <span class="font-weight-bold">Eingeloggt als:</span>&nbsp;<span class="primary--text font-weight-bold">{{ loggedInEmail }}</span>
          </div>
        </v-toolbar>
      </v-card>
      <v-main>
        <router-view></router-view>
      </v-main>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
    </v-app>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #D22321;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #D22321;

    &.router-link-exact-active {
      color: #D22321;
    }
  }
}
</style>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
  import sessionStore from "@/stores/AuthStore";
  import ErrorPopup from '@/components/ErrorPopup'
  export default {
    name: "entryPoint",
    components: {ErrorPopup},
    data: ()=> {
      return {
        drawer: true,
      }
    },
    methods: {
      itemClicked(value) {
        this.$router.push(value.link).catch(()=>{return})
      },
      logoutClicked () {
        this.$router.push('/logout').catch(()=>{return})
      }
    },
    computed: {
      mainMenu () {
        return {
          STATES_PAGE: {title: 'Endpunkte', icon: 'mdi-server', link: '/'},
          DATA_UPLOAD: {title: 'Datenupload', icon: 'mdi-upload', link: '/datenupload'},
          USER_MANAGEMENT: {title: 'Nutzerverwaltung', icon: 'mdi-account-key', link: '/nutzerverwaltung'},
          API_DOCUMENTATION: {title: 'API Dokumentation', icon: 'mdi-api', link: '/api'},
          IMPRINT: {title: 'Impressum', icon:'', link:'/impressum'}
        }
      },
      menuItems () {
        if (this.isAdminOrSuperAdmin) {
          return [
              this.mainMenu.STATES_PAGE,
              this.mainMenu.DATA_UPLOAD,
              this.mainMenu.USER_MANAGEMENT,
              this.mainMenu.API_DOCUMENTATION,
              this.mainMenu.IMPRINT
          ]
        }
          return [
              this.mainMenu.STATES_PAGE,
              this.mainMenu.DATA_UPLOAD,
              this.mainMenu.API_DOCUMENTATION,
              this.mainMenu.IMPRINT
          ]
      },
      isLoggedIn() {
        return sessionStore.state.isLoggedIn()
      },
      currentPath () {
        return this.$route.path
      },
      isAdminOrSuperAdmin () {
        return sessionStore.state.isSuperAdmin() || sessionStore.state.isAdmin()
      },
      loggedInEmail () {
        return sessionStore.state.user ? sessionStore.state.user.email : ''
      }
    }
  }
</script>

<style>
 li {
   display: inline-block;
   padding: 8px 16px 8px 8px;
   color: #D22321;
   cursor: pointer !important;
   font-weight: bold;
 }

 .no_highlight {
   -webkit-touch-callout: none; /* iOS Safari */
   -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
   -moz-user-select: none; /* Old versions of Firefox */
   -ms-user-select: none; /* Internet Explorer/Edge */
   user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
 }

 .active {
   color: black;
 }

 .v-toolbar__title {
   font-size: 38px !important;;
   color: #D22321;
   font-weight: bold;
 }

 .align-left {
   text-align: left;
 }

 .lotto_red {
   color: #D22321;
 }

 .user-info-section {
   position: absolute;
   bottom: 0;
   right: 0;
   padding-right: 18px;
 }

 .menuItem {
   font-size: 18px;
 }
</style>